import { ISpecs } from 'app/models/specs/specs';
import { ISupplier } from 'app/models/supplier';
import * as actions from '../actions/settings';

export interface State {
  specs: ISpecs | null;
  supplierDetails: ISupplier | null;
}

const initialState: State = {
  specs: null,
  supplierDetails: null,
};

export const reducer = (state: State = initialState, action: actions.SettingsActions): State => {
  switch (action.type) {
    case actions.SET_SPECS:
      return { ...state, specs: action.payload.specs };
    case actions.SET_SUPPLIER:
      return { ...state, supplierDetails: action.payload.supplierDetails };
    default:
      return state;
  }
};
